/**
 * Gravidade — um dos **dois eixos** do alerta.
 *
 * ⚠️ Nao confundir com `AlertCategoryEnum`, que e o outro. Categoria e gravidade sao
 * exibidas em **colunas separadas** (`AJUSTES-FIGMA-UX.md` AJ-01): o badge unico do
 * Figma antigo misturava os dois e impedia a enfermeira de ver os dois ao mesmo
 * tempo, que a spec define como obrigatorio na tela.
 */
enum AlertSeverityEnum {
  MODERATE = 'moderado',
  SEVERE = 'grave',
}

export default AlertSeverityEnum;
